<div class="flex flex-col overflow-y-auto">
	<app-teranet-pin-view
		[showSimilarNames]="true"
		class="block"
	></app-teranet-pin-view>

	<div class="flex flex-col flex-1 p-10">
		<app-adjacent-properties-map
			[showBackButton]="false"
		></app-adjacent-properties-map>
	</div>
</div>

<ui-content-footer
	[primaryAction]="{ text: 'Continue', action: next }"
	[secondaryAction]="{ text: 'Back', action: back }"
	[testHook]="testHooks.ContentFooter"
></ui-content-footer>
